module.exports = __webpack_public_path__ + "static/img/third1_2.18eea18a.png";